// extracted by mini-css-extract-plugin
export var employee = "TeamWithDescriptions-module--employee--92G-X";
export var header = "TeamWithDescriptions-module--header--4Im7d";